import React from 'react';
import UpwardLogo from 'components/Logo';
import {
   Navbar,
} from 'reactstrap';

const NavbarLite = (props) => {
   return (
      <Navbar
         fixed='top'
         expand
      >
         <span className='sidebar-brand my-1'>
            <UpwardLogo fill='#444'/>
         </span>
      </Navbar>
   );
};

export default NavbarLite;
